export default __webpack_public_path__ + "static/media/Flag_of_Liechtenstein.e21d9db1.svg";